import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function DoctorSkeleton() {
  return (
    <div className="doctor-card doctor-skeleton">
      <Skeleton height={120} borderRadius={10} /> {/* Image */}
      <Skeleton height={20} width="70%" style={{ marginTop: "10px" }} /> {/* Name */}
      <Skeleton height={18} width="50%" /> {/* Specialization */}
      <Skeleton height={16} count={2} /> {/* paragraph */}
      <Skeleton height={35} width="100%" borderRadius={8} style={{ marginTop: "10px" }} /> {/* Button */}
    </div>
  );
}
